export default __webpack_public_path__ + "static/media/icon-eye.52999197.svg";